import React, { useState } from "react";
import { Box, TextField, Button, Grid, Autocomplete } from "@mui/material";

const countries = [
  { code: "US", label: "United States" },
  { code: "CA", label: "Canada" },
  { code: "AU", label: "Australia" },
  { code: "GB", label: "United Kingdom" },
  { code: "IN", label: "India" },
];

const UpdatePersonalDetails = ({ handleCloseDialog }) => {
  const [country, setCountry] = useState(null);

  return (
    <Box mt={2}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField label="First Name" variant="outlined" fullWidth />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField label="Last Name" variant="outlined" fullWidth />
        </Grid>

        <Grid item xs={12}>
          <TextField label="Email" variant="outlined" fullWidth disabled />
        </Grid>

        <Grid item xs={12}>
          <Autocomplete
            options={countries}
            getOptionLabel={(option) => option.label}
            value={country}
            onChange={(event, newValue) => setCountry(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Country"
                variant="outlined"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField label="City" variant="outlined" fullWidth />
        </Grid>

        <Grid item xs={12} container justifyContent="flex-end" spacing={1}>
          <Grid item>
            <Button
              variant="outlined"
              color="error"
              onClick={handleCloseDialog}
            >
              Cancel
            </Button>
          </Grid>
          <Grid item>
            <Button variant="contained" color="secondary" type="submit">
              Update
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default UpdatePersonalDetails;
